import React from 'react';
import { PublicQuestionsType } from 'types/course.type';
import fa from 'locales/fa.json';
import Link from 'next/link';
import { ConsultingQuestionsRoute, SingleQuestionRoute } from 'services/routes';
import { useRouter } from 'next/router';

const QuestionCard: React.FC<{ question: PublicQuestionsType }> = ({ question }) => {
  const router = useRouter();
  const handleTagClick = (e, tag): void => {
    e.preventDefault();
    router.push(ConsultingQuestionsRoute(tag));
  };
  return (
    <Link href={SingleQuestionRoute(question.id)}>
      <a className="mb-6 flex flex-col rounded-xl cursor-pointer bg-white p-5 shadow-note">
        <div className="flex items-center justify-between">
          <div className="mb-2 font-semibold px-3 text-14 text-black80">
            {question.category.name}
          </div>
          <div className="flex gap-[8px] justify-end flex-wrap">
            {question.tags.map((tag) => (
              <div
                onClick={(e): void => handleTagClick(e, tag)}
                key={tag}
                className="text-[11px] bg-green60 text-white shrink-0 py-[1px] px-[4px] rounded-[4px]"
              >
                {tag}
              </div>
            ))}
          </div>
        </div>
        <div className="p-2 font-regular text-12 text-black60">{question.content}</div>
        <div className="rounded-xl mt-3 bg-berry10 p-3">
          <div className="mb-2 font-semibold text-14 text-berry80">
            {fa.global.advisorAnswer}
          </div>
          <div className="p-2 font-regular text-12 text-black60">
            {question.answer || 'هنوز پاسخی ثبت نشده است.'}
          </div>
        </div>
      </a>
    </Link>
  );
};

export default QuestionCard;
